import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, of, observable, Subject, BehaviorSubject, ReplaySubject } from 'rxjs';

import * as _ from 'lodash';
@Injectable({
  providedIn: 'root'
})
export class StateService {
    user:any = new BehaviorSubject("");
    dossier:any = new BehaviorSubject("");
    loader:any = new BehaviorSubject(true);
    constructor(
        private http: HttpClient
    ) {}

    updateUser(user:any){
        this.user.next(user);
    }

    updateDossier(dossier:any){
        this.dossier.next(dossier);
    }

    updateLoader(visible: boolean){
        this.loader.next(visible);
    }
}